<template>
	<v-card class='comment-form elevation-0'>
		<v-form
			ref='form'
			v-model='valid'
			lazy-validation
			@submit.prevent='validateAndSubmit'
		>
			<div class='d-flex comment-form__text-outer'>

				<Avatar class='mr-6 mt-2 mb-3' size='50' :avatar='this.profile.user_logo' />

				<div style='width: 100%;'>
					<v-textarea
						color='#000'
						class='comment-form__textarea' rows='1'
						label='Your comment ...'
						:value='fields.content'
						v-model='fields.content'
						:error-messages='field_errors.content'
						:rules='rules.content'
						required
					></v-textarea>
					<v-btn
						:loading='loading'
						@click='validateAndSubmit'
						class='comment-form__button elevation-0'
					>
						Comment
					</v-btn>
				</div>
			</div>
			<p v-for='(index, error) in errors' :key='index' class='red--text'>
				{{ error }}
			</p>
		</v-form>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from '@/mixins/Form'
import { ruleRequired } from '@/utils/rules'
import Avatar from '@/components/Avatar'

export default {
	name: 'CommentForm',
	components: {
		Avatar,
	},
	mixins: [Form],
	props: {
		isReply: {
			type: Boolean,
			default: false,
		},
		parent: {
			type: Object,
			default: () => {
			},
		},
		post: {
			type: Object,
			default: () => {
			},
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		comment: {
			type: Object,
			default: () => {
			},
		},
	},
	data: () => ({
		fields: {
			content: '',
		},
	}),
	methods: {
		...mapActions('post', ['addReply']),

		submitForm() {
			this.field_errors = {}

			const {
				comment: { id: parentCommentId },
				post: { thread_id },
			} = this.$props

			return this.addReply({
				thread_id: thread_id,
				reply_text: this.fields.content,
				parent_id: parentCommentId,
				isPost: this.$route.name === 'posts-by-id',
				thread_title: this.post.thread_title
			})
		},
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),
		rules() {
			return {
				content: [
					v => ruleRequired(v) || 'Field is required.',
					v => !!v.trim().length || 'Text cannot be empty'
				],
			}
		},
	},
}
</script>

<style scoped lang='scss'>
.comment-form {
	font-family: Montserrat, sans-serif;
	font-style: normal;
	background-color: rgb(246, 246, 246) !important;
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
	letter-spacing: 0.5px;

	&__textarea {
		max-width: 654px;
		background-color: rgb(246, 246, 246) !important;
		color: #000;
		border-radius: 10px;

		&:focus {
			.v-input__slot {
				border: 1px solid #000000;
			}
		}

		.v-input__slot {
			box-shadow: none !important;
			border: 1px solid rgba(0, 0, 0, 0.2);
		}
	}

	&__button {
		border-radius: 29px !important;
		background-color: var(--accent-color) !important;
		color: #fff !important;
		text-transform: none;
	}

	@media screen and (max-width: 400px) {
		&__text-outer {
			flex-direction: column;
		}
	}

	.v-btn.v-btn--is-elevated {
		color: white !important;
	}
}

</style>
